"use client";
import React from "react";
import Grid from "@mui/material/Grid";
import SideNav from "./navigation/Navigation";
import MobileNavSheet from "./navigation/MobileNavSheet";
import "./AdminRootContainer.scss";

export default function RootContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Grid 
      className="admin-root-container" 
      container 
      wrap="nowrap"
      sx={{
        height: "100vh",
        overflow: "hidden"
      }}
    >
      <SideNav />
      <MobileNavSheet />
      <Grid
        item
        className="admin-root-children"
        sx={{
          flexGrow: 1,
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
}
